"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsedRewardMap = exports.RewardEndpoint = exports.RewardStatus = exports.KeyType = exports.RewardType = exports.GamingPlatform = void 0;
/**
 * @readonly
 * @enum {import('@dd/types/rewards').GamingPlatformTypeDef}
 */
exports.GamingPlatform = {
    STEAM: 'steam',
    SWITCH: 'switch',
    PS_4: 'ps4',
    PS_5: 'ps5',
    IOS: 'ios',
    ANDROID: 'android',
    PLAYSTATION_VR: 'playstationVR',
    OCULUS_QUEST: 'oculusQuest',
    OCULUS_RIFT: 'oculusRift',
    EPIC_GAMES_STORE: 'epicGamesStore',
    XBOX: 'xbox',
    XBOX_360: 'xbox360',
    XBOX_ONE: 'xboxOne',
    GOG: 'gog',
    INDEX: 'index',
    ITCH_IO: 'itch.io',
    VIVE: 'vive',
};
/**
 * @readonly
 * @enum {import('@dd/types/rewards').RewardTypeDef}
 */
exports.RewardType = {
    KEY: 'dropKey',
    DELIVERED_KEY: 'dropDeliveredKey',
    CODE: 'dropCode',
    DELIVERED_CODE: 'dropDeliveredCode',
    CUSTOM: 'customProduct',
    GIFTED_KEY: 'giftedKey',
    GIFTED_CODE: 'giftedCode',
};
/**
 * Enum for Reward.KEY types
 * @readonly
 * @enum {import('@dd/types/rewards').KeyTypeDef}
 */
exports.KeyType = {
    BETA: 'betaKey',
    EARLY: 'earlyKey',
    COMPLETE_EDITION: 'completeEditionKey',
    RETAIL: 'retailKey',
    SOUNDTRACK: 'soundtrackKey',
    SEASON_PASS: 'seasonPassKey',
    SPECIAL: 'specialKey',
};
/**
 * Enum for Reward statuses
 * @readonly
 * @enum {import('@dd/types/rewards').RewardStatusTypeDef}
 */
exports.RewardStatus = {
    AVAILABLE: 'available',
    USED: 'used',
};
/**
 * Enum for Reward endpoint ids
 * @readonly
 * @enum {string}
 */
exports.RewardEndpoint = {
    GET_REWARDS: 'GET_REWARDS',
    GET_INITIAL_REWARD: 'GET_INITIAL_REWARD',
    GET_CREATOR_INITIAL_REWARDS: 'GET_CREATOR_INITIAL_REWARDS',
    GET_BRAND_REWARDS: 'GET_BRAND_REWARDS',
    GET_BRAND_CUSTOM_REWARDS: 'GET_BRAND_CUSTOM_REWARDS',
    EDIT_BRAND_REWARDS: 'EDIT_BRAND_REWARDS',
    ADD_BRAND_CUSTOM_REWARD: 'ADD_BRAND_CUSTOM_REWARD',
    GET_REWARDS_FOR_CREATOR: 'GET_REWARDS_FOR_CREATOR',
    GET_REWARDS_FOR_VIEWERS: 'GET_REWARDS_FOR_VIEWERS',
    GET_DROP_KEY_REWARDS: 'GET_DROP_KEY_REWARDS',
    GET_REWARD: 'GET_REWARD',
    USE_REWARDS: 'USE_REWARDS',
    SAVE_CODE_REWARDS: 'SAVE_CODE_REWARDS',
    SAVE_KEY_REWARDS: 'SAVE_KEY_REWARDS',
    SET_DROP_DELIVERED_REWARDS_USED: 'SET_DROP_DELIVERED_REWARDS_USED',
    GET_DECRYPTED_REWARD: 'GET_DECRYPTED_REWARD',
    TRANSFER_REWARDS: 'TRANSFER_REWARDS',
};
exports.UsedRewardMap = {
    [exports.RewardType.KEY]: exports.RewardType.DELIVERED_KEY,
    [exports.RewardType.CODE]: exports.RewardType.DELIVERED_CODE,
};
